<template>
  <b-card
    no-body
    aria-controls="overlay-background"
  >
    <b-overlay
      :show="loading"
      :variant="isDarkMode ? 'dark' : 'light'"
    >
      <template v-slot:overlay>
        <loading-logo />
      </template>
      <b-card-body class="p-0">
        <vue-apex-charts
          ref="chart"
          type="bar"
          height="400"
          :options="chartOptions"
          :series="iotData"
        />
      </b-card-body>
    </b-overlay>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BOverlay } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import store from '@/store'
import moment from 'moment-timezone'
import LoadingLogo from '../miscellaneous/LoadingLogo.vue'

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardBody,
    BOverlay,
    LoadingLogo,
  },
  props: {
    iotData: {
      type: Array,
      default: () => [],
    },
    onText: {
      type: String,
      default: '',
    },
    offText: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          locales: [
            {
              name: 'es',
              options: {
                months: [
                  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
                ],
                shortMonths: [
                  'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic',
                ],
                days: [
                  'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado',
                ],
                shortDays: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
                toolbar: {
                  exportToSVG: 'Descargar SVG',
                  exportToPNG: 'Descargar PNG',
                  exportToCSV: 'Descargar CSV',
                  menu: 'Menu',
                  selection: 'Selección',
                  selectionZoom: 'Selección Zoom',
                  zoomIn: 'Acercar',
                  zoomOut: 'Alejar',
                  pan: 'Mover',
                  reset: 'Reiniciar Zoom',
                },
              },
            },
          ],
          defaultLocale: 'es',
          toolbar: {
            show: true,
          },
        },
        fill: {
          colors: [this.onColor, this.offColor],
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        legend: {
          show: false,
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: value => {
              if (value === 1) return this.onText
              if (value === -1) return this.offText
              return value
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: '#000',
            },
            offsetX: 3,
            formatter: value => {
              if (value === 1) return this.onText
              if (value === -1) return this.offText
              return value
            },
          },
          min: -1,
          max: 1,
          tickAmount: 2,
        },
        xaxis: {
          type: 'datetime',
          labels: {
            style: {
              colors: '#000',
            },
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM 'yy",
              day: 'dd MMM',
              hour: 'HH:mm',
            },
            formatter(value) {
              return moment.utc(value).local().format('DD/MM hh:mm')
            },
            offsetX: 20,
          },
        },
        noData: {
          text: 'No hay datos para mostrar',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#008FFB',
            fontSize: '26px',
            fontFamily: undefined,
          },
        },
      },
    }
  },
  computed: {
    isDarkMode() {
      return store.state.appConfig.layout.skin === 'dark'
    },
  },
  watch: {
  iotData: {
    handler(newSeries) {
      if (this.$refs.chart) {
        this.$refs.chart.updateSeries(newSeries, true);
      }
    },
    deep: true
  }
}
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";
.apexcharts-toolbar {
  z-index: 0 !important;
}
</style>